import {
  faBars,
  faChartSimple,
  faLightbulb,
  faLongArrowAltUp,
  faPrint,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import Tabs from '../../../../../Components/Tabs'
import { BodyDrawer, PdfPrintRelatorio } from '../../styles'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { Empty, Modal, Tag } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { TitleH1 } from '../../../../../Components/CustomUi/titleH1'
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js'
import React, { useEffect, useState } from 'react'
import { Switcher } from '../../../../../Components/CustomUi/Switcher'
import {
  criarSugestoes,
  dadosGrafico,
  filtrarDadosSugestoes,
  filtrarOsSentidos,
  intercalarSentidos,
  processarArray,
  tratarDadosFiltrar,
  verificarCvCoresGraficos,
} from './meta'
import { calculoResumo, Graficos } from './graficos'
import { getBarChartBase64 } from './meta/grafico'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box } from '../../../../../Components/CustomUi/box'
import { Select } from '../../../../../Components/CustomUi/Select'
import { orderBy } from 'lodash'
import {
  getTipoConsultor,
  ItensTipoConsultorTypes,
} from '../../../../../services/consultoriaAgricola/tipoConsultor'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

export type PropsSugestoes = {
  titulo: string
  descricao: string
}

interface PropsRelatorio {
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  nome_consultor: string
  setNome_consultor: React.Dispatch<React.SetStateAction<string>>
  listar_teste_relatorios: any[]
  loading: boolean
  pdfRefPrint: React.Ref<HTMLDivElement>
  esconderSwitch: boolean
  setTotalDadosGrafico: React.Dispatch<React.SetStateAction<any[]>>
  graficoSelecionados: number[]
  graficosSelecionadosImprimir: Function
  selecionarTodosGraficos: Function
  todosSelecionados: boolean
  setTodosSelecionados: React.Dispatch<React.SetStateAction<boolean>>
  mostrarGraficos: boolean
  setMostrarGraficos: React.Dispatch<React.SetStateAction<boolean>>
  mostrarResumo: boolean
  setMostrarResumo: React.Dispatch<React.SetStateAction<boolean>>
  mostrarSugestao: boolean
  setMostrarSugestao: React.Dispatch<React.SetStateAction<boolean>>
  abrirConfig: boolean
  setAbrirConfig: React.Dispatch<React.SetStateAction<boolean>>
  gerando: boolean
  renderizarGraficos: boolean
  setRenderizarGraficos: React.Dispatch<React.SetStateAction<boolean>>
  imprimirGraficos: boolean
  propriedade: string
  nome_equipamento: string
  realizado_por: string
  imprimir: Function
}

export const Relatorios: React.FC<PropsRelatorio> = ({
  tab_selecionar_atual,
  setTab_selecionar_atual,
  nome_consultor,
  setNome_consultor,
  listar_teste_relatorios,
  loading,
  pdfRefPrint,
  esconderSwitch,
  setTotalDadosGrafico,
  graficoSelecionados,
  graficosSelecionadosImprimir,
  todosSelecionados,
  setTodosSelecionados,
  abrirConfig,
  setAbrirConfig,
  mostrarGraficos,
  setMostrarGraficos,
  mostrarResumo,
  setMostrarResumo,
  mostrarSugestao,
  setMostrarSugestao,
  gerando,
  renderizarGraficos,
  setRenderizarGraficos,
  imprimirGraficos,
  propriedade,
  nome_equipamento,
  realizado_por,
  imprimir,
}) => {
  const [loadingGrafico, setLoadingGrafico] = useState(false)
  const [dadosFinalizado, setDadosFinalizado] = useState([])
  const [dadosRenderizados, setDadosRenderizados] = useState([])
  const [dadosTabelaResumo, setDadosTabelaResumo] = useState<calculoResumo>()
  const [dadosSugestoes, setDadosSugestoes] = useState<PropsSugestoes[]>([])
  const [open_consultor, setOpen_consultor] = useState<boolean>(false)
  const [dataConsultor, setDataConsultor] = useState<ItensTipoConsultorTypes[]>([])
  const [data, setData] = useState([])
  const [dataParaTratar, setDataParaTratar] = useState([])

  const listConsultor = async () => {
    const resp = await getTipoConsultor({ codCliente: null })

    setDataConsultor(resp?.data?.itens)
  }

  function gerarDados() {
    const dadosSugestoesOriginal = filtrarDadosSugestoes(listar_teste_relatorios)
    const sugestoes = criarSugestoes(dadosSugestoesOriginal)
    setDadosSugestoes(sugestoes)

    const calculos = listar_teste_relatorios?.map((data) => {
      return {
        calculo: data?.calculo.slice(0, 44),
        data: data?.data,
      }
    })

    setDadosTabelaResumo(calculos[0])

    const dadosFiltradosTratados = tratarDadosFiltrar(calculos[0]?.calculo)
    const dadosFinal = dadosFiltradosTratados?.map((item) => {
      const cores = Object.values(item?.dados as string).map((rec) => {
        if (typeof rec === 'string' && rec.includes('_coluna')) {
          return item?.sentido === 12 ? 'red' : 'blue'
        } else {
          return item?.sentido === 12 ? 'rgba(0, 123, 255, 0.5)' : 'red'
        }
      })
      const numeros = Object.values(item?.dados).map((value) => {
        if (typeof value === 'string' && value.includes('_coluna')) {
          return parseInt(value.replace('_coluna', ''), 10)
        } else if (typeof value === 'string') {
          return parseInt(value, 10)
        }
      })

      return {
        ...item,
        dados: {
          numero: numeros,
          cor: cores,
        },
      }
    })

    setDadosFinalizado(dadosFinal)
    const dadosTratados = intercalarSentidos(dadosFinal)
    tratandoDados(dadosTratados)
  }

  function tratandoDados(dados) {
    const dadosParaGrafico = dados?.map((item) => {
      return {
        ...item,
        grafico11: getBarChartBase64(dadosGrafico(item, 1)),
        grafico12: getBarChartBase64(dadosGrafico(item, 2)),
      }
    })

    setDadosRenderizados(dadosParaGrafico)
  }

  useEffect(() => {
    gerarDados()
  }, [listar_teste_relatorios])

  useEffect(() => {
    setLoadingGrafico(true)
    if (dadosFinalizado?.length > 0) {
      setTimeout(() => {
        setLoadingGrafico(false)
      }, 3000)
    }

    if (dadosFinalizado?.length <= 0) {
      setLoadingGrafico(false)
    }
    setTotalDadosGrafico(dadosRenderizados)
    setTodosSelecionados(true)
  }, [dadosFinalizado])

  useEffect(() => {
    if (
      tab_selecionar_atual === 'Gráficos' &&
      loadingGrafico === false &&
      dadosFinalizado?.length > 0
    ) {
      setRenderizarGraficos(true)

      setTimeout(() => {
        setRenderizarGraficos(false)
      }, 800)
    }
  }, [tab_selecionar_atual])

  useEffect(() => {
    listConsultor()
  }, [])

  return (
    <BodyDrawer>
      <Render condition={!loadingGrafico && dadosFinalizado?.length > 0}>
        <TitleH1>Relatórios</TitleH1>
        <Render condition={gerando === false}>
          <Tabs
            tabs={[
              { descricao: 'Resumo', icone: faBars },
              { descricao: 'Gráficos', icone: faChartSimple },
              { descricao: 'Sugestões', icone: faLightbulb },
            ]}
            selecionado={tab_selecionar_atual}
            trackWidth={263}
            onChange={setTab_selecionar_atual}
          />
        </Render>
        <Render condition={tab_selecionar_atual === 'Resumo'}>
          <div>
            <div className='titulo__resumo'>
              <h3>Sentidos opostos de aplicação (Vai e vem)</h3>
              <div style={{ display: 'flex', gap: '5px' }}>
                <FontAwesomeIcon className='seta' fontSize={15} icon={faLongArrowAltUp} />
                <FontAwesomeIcon
                  className='seta'
                  fontSize={15}
                  style={{ rotate: '180deg' }}
                  icon={faLongArrowAltUp}
                />
              </div>
            </div>
            <HeaderTable
              itens={[
                { valor: 'Largura', width: '150px' },
                { valor: 'CV%', width: 'calc(100% - 600px)' },
                { valor: 'Mínima(kg/ha)', width: '150px' },
                { valor: 'Máxima(kg/ha)', width: '150px' },
                { valor: 'Média(kg/ha)', width: '150px' },
              ]}
            />

            <BodyTable
              style={{
                height: (dadosTabelaResumo?.calculo ?? []).length < 8 && 'auto',
                position: 'relative',
                overflowX: 'hidden',
                overflowY: 'hidden',
                marginTop: -10,
              }}
            >
              <Render condition={!loading}>
                {(dadosTabelaResumo?.calculo ?? [])
                  .filter((rec) => rec?.sentido === 12)
                  .slice(0, 22)
                  .map((item, index) => {
                    return (
                      <RowTable
                        key={item.cod}
                        onDoubleClick={() => {}}
                        style={{
                          pageBreakInside: 'avoid',
                          height: index === 0 ? '50px' : '45px',
                        }}
                      >
                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}>
                            {`${item?.largura} m`}
                          </div>
                        </RowItem>

                        <RowItem fontSize={13} width={'calc(100% - 600px)'}>
                          <Tag
                            style={{
                              backgroundColor: verificarCvCoresGraficos(item?.cv)[0]?.backGround,
                              border: `2px solid ${verificarCvCoresGraficos(item?.cv)[0]?.border}`,
                              color: verificarCvCoresGraficos(item?.cv)[0]?.color,
                              marginTop: index === 0 ? '10px' : 0,
                            }}
                          >
                            {item?.cv}
                          </Tag>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}>{item?.minima}</div>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}> {item?.maxima}</div>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}> {item?.media}</div>
                        </RowItem>
                      </RowTable>
                    )
                  })}
              </Render>

              <Render condition={listar_teste_relatorios?.length === 0 && !loading}>
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<> Nenhum registro disponível!</>}
                />
              </Render>

              <Render condition={loading}>
                <Carregando
                  animation
                  legenda='Carregando relatórios...'
                  justifyContent='center'
                  height={700}
                  size='default'
                />
              </Render>
            </BodyTable>
            <div className='titulo__resumo'>
              <h3> Mesmo sentido de aplicação (Vai e vai)</h3>
              <div style={{ display: 'flex', gap: '5px' }}>
                <FontAwesomeIcon className='seta' fontSize={15} icon={faLongArrowAltUp} />
                <FontAwesomeIcon className='seta' fontSize={15} icon={faLongArrowAltUp} />
              </div>
            </div>
            <HeaderTable
              itens={[
                { valor: 'Largura', width: '150px' },
                { valor: 'CV%', width: 'calc(100% - 600px)' },
                { valor: 'Mínima', width: '150px' },
                { valor: 'Máxima', width: '150px' },
                { valor: 'Média', width: '150px' },
              ]}
            />

            <BodyTable
              style={{
                height: (dadosTabelaResumo?.calculo ?? []).length < 8 && 'auto',
                position: 'relative',
                overflowX: 'hidden',
                overflowY: 'hidden',
                marginTop: -10,
              }}
            >
              <Render condition={!loading}>
                {(dadosTabelaResumo?.calculo ?? [])
                  .filter((rec) => rec?.sentido === 11)
                  .slice(0, 22)
                  .map((item, index) => {
                    return (
                      <RowTable
                        key={item.cod}
                        onDoubleClick={() => {}}
                        style={{
                          pageBreakInside: 'avoid',
                          height: index === 0 ? '50px' : '45px',
                        }}
                      >
                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}>
                            {`${item?.largura} m`}
                          </div>
                        </RowItem>

                        <RowItem fontSize={13} width={'calc(100% - 600px)'}>
                          <Tag
                            style={{
                              backgroundColor: verificarCvCoresGraficos(item?.cv)[0]?.backGround,
                              border: `2px solid ${verificarCvCoresGraficos(item?.cv)[0]?.border}`,
                              color: verificarCvCoresGraficos(item?.cv)[0]?.color,
                              marginTop: index === 0 ? '10px' : 0,
                            }}
                          >
                            {item?.cv}
                          </Tag>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}>{item?.minima}</div>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}> {item?.maxima}</div>
                        </RowItem>

                        <RowItem fontSize={13} width={'150px'}>
                          <div style={{ marginTop: index === 0 ? '10px' : 0 }}> {item?.media}</div>
                        </RowItem>
                      </RowTable>
                    )
                  })}
              </Render>

              <Render condition={listar_teste_relatorios?.length === 0 && !loading}>
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<> Nenhum registro disponível!</>}
                />
              </Render>

              <Render condition={loading}>
                <Carregando
                  animation
                  legenda='Carregando relatórios...'
                  justifyContent='center'
                  height={700}
                  size='default'
                />
              </Render>
            </BodyTable>
          </div>
        </Render>
        <Render condition={tab_selecionar_atual === 'Gráficos'}>
          <PdfPrintRelatorio id='printMonitoramento' ref={pdfRefPrint}>
            <Render condition={esconderSwitch === false}>
              <Switcher
                label={'Selecionar todos os gráficos'}
                isChecked={todosSelecionados}
                trigger={setTodosSelecionados}
                disabled={gerando}
              />
            </Render>

            <Graficos
              renderizarGraficos={renderizarGraficos}
              esconderSwitch={esconderSwitch}
              dadosFinalizados={dadosRenderizados}
              graficoSelecionados={graficoSelecionados}
              graficosSelecionadosImprimir={graficosSelecionadosImprimir}
              gerando={gerando}
              imprimirGraficos={imprimirGraficos}
              mostrarGraficos={mostrarGraficos}
              mostrarResumo={mostrarResumo}
              mostrarSugestoes={mostrarSugestao}
              listar_resumo_teste={dadosTabelaResumo}
              dadosSugestoes={dadosSugestoes}
              todosSelecionados={todosSelecionados}
              propriedade={propriedade}
              nome_equipamento={nome_equipamento}
              realizado_por={realizado_por}
              nome_consultor={nome_consultor}
            />
          </PdfPrintRelatorio>
        </Render>
        <Render condition={tab_selecionar_atual === 'Sugestões'}>
          <Box padding={'20px'} style={{ gap: '0px' }}>
            {dadosSugestoes?.map((item, index) => {
              return (
                <div key={index}>
                  <label style={{ fontWeight: '700' }}>{item?.titulo}</label>
                  <p>{item?.descricao}</p>
                </div>
              )
            })}
          </Box>
        </Render>
      </Render>
      <Render condition={gerando}>
        <div className='overlay'>
          <Carregando
            animation
            legenda='Gerando relatório...'
            justifyContent='center'
            height={700}
            size='default'
          />
        </div>
      </Render>
      <Render condition={renderizarGraficos}>
        <Carregando
          animation
          legenda='Gerando gráficos...'
          justifyContent='center'
          height={700}
          size='default'
        />
      </Render>
      <Render condition={loadingGrafico}>
        <Carregando
          animation
          legenda='Carregando dados...'
          justifyContent='center'
          height={700}
          size='default'
        />
      </Render>
      <Render condition={dadosFinalizado?.length <= 0}>
        <div style={{ display: 'flex', justifyContent: 'center', height: '600px' }}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<> Nenhum registro disponível!</>}
          />
        </div>
      </Render>
      <Modal
        onCancel={() => {
          setAbrirConfig(false)
          setMostrarGraficos(true)
          setMostrarResumo(true)
          setMostrarSugestao(true)
          setNome_consultor('')
        }}
        destroyOnClose
        style={{ minWidth: '10%', padding: '10px' }}
        open={abrirConfig}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
        footer={
          <div style={{ borderTop: '1px solid #d9d9d9', paddingTop: '10px' }}>
            <ButtonCustom onClick={imprimir} icon={<FontAwesomeIcon icon={faPrint} />}>
              Imprimir
            </ButtonCustom>
          </div>
        }
      >
        <div>
          <div style={{ marginTop: '20px' }}>
            <label style={{ fontSize: '13px', fontWeight: '600' }}>Configuração de impressão</label>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}
            >
              <Select
                label='Consultor responsável'
                placeholder='Selecione o consultor responsável'
                descricaoItem='usuario_nome'
                idItem='cod'
                items={orderBy(dataConsultor ?? [], 'usuario_nome', ['asc'])}
                // items={lista_consultores}
                open={open_consultor}
                trigger={setOpen_consultor}
                onChange={setNome_consultor}
                value={nome_consultor}
                icon={faUser}
              />
              <Switcher
                label={'Mostrar resumo'}
                isChecked={mostrarResumo}
                trigger={setMostrarResumo}
                disabled={gerando}
              />
              <Switcher
                label={'Mostrar gráficos'}
                isChecked={mostrarGraficos}
                trigger={setMostrarGraficos}
                disabled={gerando}
              />
              <Switcher
                label={'Mostrar sugestões'}
                isChecked={mostrarSugestao}
                trigger={setMostrarSugestao}
                disabled={gerando}
              />
            </div>
          </div>
        </div>
      </Modal>
    </BodyDrawer>
  )
}
